import "./FrequentlyAskedQuestions.module.css";
import Navbar from "@/reusable_sections/Header";
import Faq from "./sections/Faq";
import Action from "./sections/Action";
import Footer from "@/reusable_sections/Footer";
export default function FrequentlyAskedQuestionsPage() {
  return <div>
      <Navbar />
      <Faq />
      <Action />
      <Footer />
    </div>;
}